import { Box, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import { TabContext, TabPanel } from "@mui/lab";
import AllClient from "./clientsList/AllClient";
import InHouseClients from "./clientsList/InHouseClients";
import AftercareClients from "./clientsList/AftercareClients";
import InactiveClients from "./clientsList/InactiveClients";
import MiraclesAtHomeClients from "./clientsList/MiraclesAtHomeClients";
import IncomingClients from "./clientsList/IncomingClients";
import ClinicalAssessmentClient from "./clientsList/ClinicalAssessmentClient";
import ContinuedTherapy from "./clientsList/ContinuedTherapy";
import DeniedClients from "./clientsList/DeniedClients";
import PotentialClients from "./clientsList/PotentialClients";
import { useLocation } from "react-router-dom";

const statusToTabValue = {
  "In house": "1",
  Inhouse: "1",
  inhouse: "1",
  Incoming: "2",
  incoming: "2",
  Potential: "3",
  potential: "3",
  "Clinical Assessment": "4",
  clinicalAssessment: "4",
  "clinical-assessment": "4",
  Aftercare: "5",
  aftercare: "5",
  "Miracles@home": "6",
  miraclesAtHome: "6",
  "miracles-at-home": "6",
  "Continued Therapy": "7",
  continuedTherapy: "7",
  "continued-therapy": "7",
  Inactive: "8",
  inactive: "8",
  "Denied Admission": "9",
  deniedAdmission: "9",
  "denied-admission": "9",
  All: "10",
  all: "10",
};

function ClientsTabMobile({
  userRole = "",
  therapistFilter = null,
  rehabFilter = null,
  initialTab = null,
}) {
  const [value, setValue] = useState(statusToTabValue[initialTab] || "1");
  const isPhilippinesView = rehabFilter === "miracles_asia_philippines";
  const inHouseTabLabel = isPhilippinesView ? "Active" : "Inhouse";
  const incomingTabLabel = "Incoming";
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const location = useLocation();
  const isExternal = userRole === "External";

  useEffect(() => {
    // Si l'état est passé avec un statut client, sélectionnez l'onglet correspondant
    if (location.state?.selectedTab) {
      const tabValue = statusToTabValue[location.state.selectedTab];
      if (tabValue) {
        setValue(tabValue);
        return;
      }
    }

    const tabValue = statusToTabValue[initialTab];
    if (tabValue) {
      setValue(tabValue);
    }
  }, [location, initialTab]);

  useEffect(() => {
    if (userRole === "External") {
      setValue("10");
    }
  }, [userRole]);

  return (
    <div className="tab-client-container">
      <Box>
        <TabContext value={value}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divier",
              width: "100%",
              marginLeft: "10px",
            }}
          >
            <Tabs
              variant="scrollable"
              allowScrollButtonsMobile
              value={value}
              onChange={handleChange}
              // classes={classes}
              aria-label="simple tabs example"
            >
              {(isExternal
                ? [<Tab key="10" label="All" value="10" />]
                : [
                    (userRole === "Admin" ||
                      userRole === "Super Admin" ||
                      userRole === "Admission staff" ||
                      userRole === "Therapist" ||
                      userRole === "Support Staff" ||
                      userRole === "Psycho-ed" ||
                      userRole === "Finance team" ||
                      userRole === "Medical Staff" ||
                      userRole === "Hospitality Staff" ||
                      userRole === "Clinical Director") && (
                      <Tab key="1" label={inHouseTabLabel} value="1" />
                    ),
                    userRole !== "External" && (
                      <Tab key="2" label={incomingTabLabel} value="2" />
                    ),
                    userRole !== "Hospitality Staff" && (
                      <Tab key="4" label="Clinical Assessment" value="4" />
                    ),
                    <Tab key="5" label="Aftercare" value="5" />,
                    (userRole === "Admin" ||
                      userRole === "Therapist" ||
                      userRole === "Super Admin" ||
                      userRole === "Admission staff" ||
                      userRole === "Support Staff" ||
                      userRole === "Psycho-ed" ||
                      userRole === "Finance team" ||
                      userRole === "Medical Staff" ||
                      userRole === "Hospitality Staff" ||
                      userRole === "Clinical Director") && (
                      <Tab key="6" label="Miracles@home" value="6" />
                    ),
                    (userRole === "Admin" ||
                      userRole === "Therapist" ||
                      userRole === "Super Admin" ||
                      userRole === "Admission staff" ||
                      userRole === "Support Staff" ||
                      userRole === "Psycho-ed" ||
                      userRole === "Finance team" ||
                      userRole === "Medical Staff" ||
                      userRole === "Hospitality Staff" ||
                      userRole === "Clinical Director") && (
                      <Tab key="7" label="Continued Therapy" value="7" />
                    ),
                    (userRole === "Admin" ||
                      userRole === "Therapist" ||
                      userRole === "Super Admin" ||
                      userRole === "Admission staff" ||
                      userRole === "Support Staff" ||
                      userRole === "Psycho-ed" ||
                      userRole === "Finance team" ||
                      userRole === "Medical Staff" ||
                      userRole === "Hospitality Staff" ||
                      userRole === "Clinical Director") && (
                      <Tab key="8" label="Inactive" value="8" />
                    ),
                    (userRole === "Admin" ||
                      userRole === "Therapist" ||
                      userRole === "Super Admin" ||
                      userRole === "Admission staff" ||
                      userRole === "Support Staff" ||
                      userRole === "Psycho-ed" ||
                      userRole === "Finance team" ||
                      userRole === "Medical Staff" ||
                      userRole === "Hospitality Staff" ||
                      userRole === "Clinical Director") && (
                      <Tab key="9" label="Denied Admission" value="9" />
                    ),
                    (userRole === "Admin" ||
                      userRole === "Super Admin" ||
                      userRole === "Admission staff" ||
                      userRole === "Support Staff" ||
                      userRole === "Psycho-ed" ||
                      userRole === "Finance team" ||
                      userRole === "Medical Staff" ||
                      userRole === "Therapist" ||
                      userRole === "Hospitality Staff" ||
                      userRole === "Clinical Director") && (
                      <Tab key="10" label="All" value="10" />
                    ),
                  ]
              ).filter(Boolean)}
            </Tabs>
          </Box>
          {(() => {
            switch (value) {
              case "1":
                return (
                  <TabPanel value="1">
                    <InHouseClients view="mobile" therapistFilter={therapistFilter}
                      rehabFilter={rehabFilter} />
                  </TabPanel>
                );
              case "2":
                return (
                  <TabPanel value="2">
                    <IncomingClients view="mobile" therapistFilter={therapistFilter}
                      rehabFilter={rehabFilter} />
                  </TabPanel>
                );

              case "3":
                return (
                  <TabPanel value="3">
                    <PotentialClients view="mobile" therapistFilter={therapistFilter}
                      rehabFilter={rehabFilter} />
                  </TabPanel>
                );

              case "4":
                return (
                  <TabPanel value="4">
                    <ClinicalAssessmentClient
                      view="mobile"
                      therapistFilter={therapistFilter}
                      rehabFilter={rehabFilter}
                    />
                  </TabPanel>
                );

              case "5":
                return (
                  <TabPanel value="5">
                    <AftercareClients view="mobile" therapistFilter={therapistFilter}
                      rehabFilter={rehabFilter} />
                  </TabPanel>
                );
              case "6":
                return (
                  <TabPanel value="6">
                    <MiraclesAtHomeClients
                      view="mobile"
                      therapistFilter={therapistFilter}
                      rehabFilter={rehabFilter}
                    />
                  </TabPanel>
                );
              case "7":
                return (
                  <TabPanel value="7">
                    <ContinuedTherapy view="mobile" therapistFilter={therapistFilter}
                      rehabFilter={rehabFilter} />
                  </TabPanel>
                );
              case "8":
                return (
                  <TabPanel value="8">
                    <InactiveClients view="mobile" therapistFilter={therapistFilter}
                      rehabFilter={rehabFilter} />
                  </TabPanel>
                );
              case "9":
                return (
                  <TabPanel value="9">
                    <DeniedClients view="mobile" therapistFilter={therapistFilter}
                      rehabFilter={rehabFilter} />
                  </TabPanel>
                );
              case "10":
                return (
                  <TabPanel value="10">
                    <AllClient
                      view="mobile"
                      therapistFilter={therapistFilter}
                      rehabFilter={rehabFilter}
                    />
                  </TabPanel>
                );
              default:
                return null;
            }
          })()}
        </TabContext>
      </Box>
    </div>
  );
}

export default ClientsTabMobile;


